import { render, staticRenderFns } from "./ReservedHomeworkCard.vue?vue&type=template&id=73ee6940"
import script from "./ReservedHomeworkCard.vue?vue&type=script&lang=js"
export * from "./ReservedHomeworkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports